<template>
    <div class="overflow-auto pa-5 d-flex flex-column">
        <h4>{{ $t('data_relations') }}</h4>
        <KpIcon v-if="loading" icon-cls="refresh ic-spin" color="primary" size="32" />
        <DependencyView :dependencies="dependencies" single full message="" />
    </div>
</template>

<script>
import { Address } from '@/models/Address';
import { mapActions } from 'vuex';
import DependencyView from '@/components/DependencyView.vue';

export default {
    name: 'AddressRelations',
    components: {
        DependencyView,
    },
    props: {
        record: {
            type: Address,
            required: true,
        },
    },
    data() {
        return {
            dependencies: [],
            loading: true,
        };
    },
    async mounted() {
        await this.loadDependencies();
        this.loading = false;
    },
    methods: {
        ...mapActions(['runAsync']),

        async loadDependencies() {
            this.dependencies = await this.runAsync(async () => await this.record.listDependencies({ full: true }));
        },
    },
};
</script>

<style lang="scss" scoped></style>
